const ChummeryRules = () => {
    return(
        <h1>ChummeryRules</h1>
    )
}

export default ChummeryRules